 import React from 'react'
import ProductsResults from '../../components/ProductsResults'
 
const Search = ({}) => {
     return (
         <div className='searchPage'>
             <ProductsResults />
         </div>
     )
 }
 
 export default Search